import { Component, Input, OnInit } from '@angular/core';
import { trigger, transition, animate, style } from '@angular/animations'

@Component( {
    selector: 'cp-grid-legend',
    templateUrl: './grid-legend.component.html',
    styleUrls: [ './grid-legend.component.scss' ],
    animations: [
        trigger('slideInOut', [
            transition(':enter', [
                style({transform: 'translateX(100%)'}),
                animate('200ms ease-in', style({transform: 'translateX(0%)'}))
            ]),
            transition(':leave', [
                animate('200ms ease-in', style({transform: 'translateX(100%)'}))
            ])
        ])
    ]
} )
export class GridLegendComponent implements OnInit {

    legend: boolean = false;
    public type: string = '';
    @Input() tableType: string;

    public toggleText = "Hide";
    public show = false;

    constructor() {
    }

    ngOnInit() {
    }

    /*toggleLegend() {
        this.legend = !this.legend;
        console.log(this.legend);
    }*/

    public onToggle(): void {
        this.show = !this.show;
    }
}
